import React from 'react'
import HP from "../assets/images/logo/hp.png";
import Dell from "../assets/images/logo/Dell.webp";
import HikVision from "../assets/images/logo/Hikvision.svg";
import AhHua from "../assets/images/logo/ajhua.webp";
import Cisco from "../assets/images/logo/cisco.webp";
import APC from "../assets/images/logo/APC.webp";
import Samsung from "../assets/images/logo/Samsung.webp";
import Apple from "../assets/images/logo/apple.webp";
import Toshiba from "../assets/images/logo/Toshiba.webp";
import Lenovo from "../assets/images/logo/Lenovo.webp";
import Oracle from "../assets/images/logo/Oracle.webp";
import Microsoft from "../assets/images/logo/Microsoft.webp";
import Sophos from "../assets/images/logo/Sophos.webp";
import Kaspersky from "../assets/images/logo/kaspersky.svg";
import Epson from "../assets/images/logo/Epson.svg";
import Logitech from "../assets/images/logo/Logitech.webp";
import Ubiquiti from "../assets/images/logo/Ubiquiti.webp";
import DLink from "../assets/images/logo/Dlink.webp";
import Seagate from "../assets/images/logo/Seagate.svg";
// import WD from "../assets/images/logo/WD.svg";
import Symantec from "../assets/images/logo/Symantec.webp";
import ZKT from "../assets/images/logo/ZKT.webp";
import MikroTik from "../assets/images/logo/mikrotik.webp";
import Synology from "../assets/images/logo/synology.webp";
import Systemax from "../assets/images/logo/Systemax.webp";
import Mecury from "../assets/images/logo/ZKT.webp";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";


const Partners = () => {

      const partner = [
        {
          id: 6,
          path: Dell,
        },
        {
          id: 1,
          path: Cisco,
        },
        {
          id: 2,
          path: AhHua,
        },
        {
          id: 3,
          path: HikVision,
        },
        {
          id: 4,
          path: APC,
        },
        {
          id: 5,
          path: HP,
        },
        {
          id: 7,
          path: Samsung,
        },
        {
          id: 8,
          path: Apple,
        },
        {
          id: 9,
          path: Toshiba,
        },
        {
          id: 10,
          path: Lenovo,
        },
        {
          id: 11,
          path: Oracle,
        },
        {
          id: 12,
          path: Microsoft,
        },
        {
          id: 13,
          path: Sophos,
        },
        {
          id: 14,
          path: Kaspersky,
        },
        {
          id: 15,
          path: Epson,
        },
        {
          id: 16,
          path: Logitech,
        },
        {
          id: 17,
          path: Ubiquiti,
        },
        {
          id: 18,
          path: DLink,
        },
        {
          id: 19,
          path: Seagate,
        },
        // {
        //   id: 20,
        //   path: WD,
        // },
        {
          id: 21,
          path: Symantec,
        },
        {
          id: 22,
          path: ZKT,
        },
        {
          id: 23,
          path: MikroTik,
        },
        {
          id: 24,
          path: Synology,
        },
        {
          id: 25,
          path: Systemax,
        },
      ];



  return (
    <>
      <div className="container mx-auto px-4">
        <div className="my-10">
          <p className="text-2xl md:text-4xl font-semibold text-darkBlue text-opacity-75">
            Tech Partners
          </p>
        </div>
        <div className="flex justify-center">
          {" "}
          <Swiper
            modules={[Autoplay]}
            spaceBetween={50}
            slidesPerView={4}
            loop={true}
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            className=""
          >
            {partner.map((partner) => (
              <SwiperSlide className="flex items-center">
                <img
                  src={partner.path}
                  alt=""
                  className="w-28 h-14 mx-auto items-center object-contain"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
}

export default Partners